import dayjs from "dayjs";
import { Component, OnInit, inject, input, output } from "@angular/core";
import { AppConfigService } from "../../../../core-ui/services/app.config.service";
import { slideFromUp } from "../../../../core-ui/core-ui.animations";
import { IDateRange } from "../../../../core-ui/models";

@Component({
  selector: "app-date-range-picker",
  templateUrl: "./date-range-picker.component.html",
  styleUrls: ["./date-range-picker.component.scss"],
  animations: [slideFromUp],
  standalone: false,
})
export class DateRangePickerComponent implements OnInit {
  readonly range = input<IDateRange>(undefined);
  readonly direction = input<"row" | "column" | "responsive">("row");

  readonly ready = output<IDateRange>();
  readonly changed = output<IDateRange>();

  open = false;
  lang: string;

  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;

  rangeToday: IDateRange = {
    startAt: this.startOfDay(dayjs()),
    endAt: this.endOfDay(dayjs()),
  };

  constructor() {
    const config = inject(AppConfigService);

    this.lang = config.language;
  }

  ngOnInit(): void {
    const range = this.range();
    if (!range) {
      this.startDate = this.rangeToday.startAt;
      this.endDate = this.rangeToday.endAt;
    } else {
      this.startDate = range.startAt;
      this.endDate = range.endAt;
    }
    this.ready.emit({
      startAt: this.startDate,
      endAt: this.endDate,
    });
  }

  rangeChange(range: IDateRange) {
    this.startDate = range.startAt;
    this.endDate = range.endAt;
    this.changed.emit(range);
  }

  startOfDay(day: dayjs.Dayjs): dayjs.Dayjs {
    return day.set("hours", 0).set("minutes", 0).set("seconds", 0);
  }

  endOfDay(day: dayjs.Dayjs): dayjs.Dayjs {
    return day.set("hours", 23).set("minutes", 59).set("seconds", 59);
  }
}
